<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="사업안내" tabActive="입지환경" bg="/images/sub/business/visual.jpg">
                <template #title>사업안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first pb-30px pb-md-40px">
            <template #tit>입지환경</template>
            <v-row>
                <template v-for="(item, index) in items">
                    <v-col :key="index" cols="6" md="3">
                        <v-card tile flat>
                            <v-card-title class="primary justify-center pa-4px mb-4px">
                                <tit class="tit--sm">
                                    {{ item.name }}
                                </tit>
                            </v-card-title>
                            <v-img :src="item.image" />
                            <v-card-text class="text-center px-0 pb-0">
                                <tit>
                                    <div class="tit--sm font-weight-semibold grey--text">
                                        {{ item.text }}
                                    </div>
                                    <div class="primary--text mt-4px">
                                        <div class="font-size-24 font-size-md-36">{{ item.minutes }}분</div>
                                        <div class="tit--xxs">({{ item.transport }})</div>
                                    </div>
                                </tit>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </template>
            </v-row>
        </page-section-primary>

        <page-section-primary titWrapClass="text-center" class="page-section--last grey lighten-5 pt-60px pt-md-80px">
            <v-row class="row--xl">
                <v-col cols="12">
                    <div class="image-wrap map-image">
                        <v-img eager src="/images/sub/business/environment/map.jpg" />
                    </div>
                </v-col>
                <v-col>
                    <tit class="font-size-24 font-size-md-36 text-center primary--text">
                        여의도 종로, 강남권역 등까지 <br class="d-none d-md-block" />
                        30분 내외로 통하는 최적의 직주근접 환경을 선사합니다!
                    </tit>
                </v-col>
            </v-row>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        Tit,
    },
    data: () => ({
        items: [
            {
                name: "시청역",
                image: "/images/sub/business/environment/environment-1.jpg",
                text: "서울시 중심업무지구",
                minutes: "25",
                transport: "지하철",
            },
            {
                name: "강남역",
                image: "/images/sub/business/environment/environment-2.jpg",
                text: "강남 중심업무지구",
                minutes: "20",
                transport: "지하철",
            },
            {
                name: "서울어린이 대공원",
                image: "/images/sub/business/environment/environment-3.jpg",
                text: "쾌적한 휴식공간",
                minutes: "8",
                transport: "차량",
            },
            {
                name: "쇼핑지구",
                image: "/images/sub/business/environment/environment-4.jpg",
                text: "롯데백화점, 이마트",
                minutes: "10",
                transport: "도보",
            },
        ],
    }),
};
</script>

<style lang="scss" scoped>
.map-image {
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);
}
</style>
